window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

document.body.addEventListener("click", async (event) => {
  if (!event.target.matches('cart-remove-button[id^="Remove"] *')) return;
  const bundle_id = event.target.closest("a.cart__remove-bundle")?.getAttribute("data-bundle-id");

  try {
    // Get current cart contents
    const cart = await (await fetch("/cart.js")).json();

    // Create data object for cart update AJAX call
    const data = {
      updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
    };

    // API call to update the cart contents and set the bundle item quantities to 0
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    response.ok && (window.location.href = "/cart");
  } catch (error) {
    console.error(error);
  }
});

// AWTOMIC Aggressive Price Fix - Directly manipulates AWTOMIC's injected elements
// Add this to your custom JS file

(function() {
    // ONLY RUN ON PRODUCT PAGES
    if (!window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/')) {
        return;
    }
    
    console.log('AWTOMIC Aggressive Fix: Initializing...');
    
    // Store variant data
    let currentVariant = null;
    let variantData = {};
    
    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }
    
    function initialize() {
        console.log('AWTOMIC Aggressive Fix: Starting...');
        
        // Capture variant data from AWTOMIC's script
        captureVariantData();
        
        // Set up observers and listeners
        setupObservers();
        setupListeners();
        
        // Do initial fix
        setTimeout(fixPrices, 500);
    }
    
    function captureVariantData() {
        // Find AWTOMIC's data script
        const scripts = document.querySelectorAll('script[type="application/json"]');
        scripts.forEach(script => {
            try {
                const data = JSON.parse(script.textContent);
                if (data && data.variants && data.widget_id) {
                    console.log('AWTOMIC Aggressive Fix: Found AWTOMIC data', data);
                    
                    // Store variant data with prices
                    data.variants.forEach(variant => {
                        variantData[variant.id] = {
                            id: variant.id,
                            price: variant.price,
                            compare_at_price: variant.compare_at_price,
                            title: variant.title,
                            // Store subscription prices from selling_plan_allocations
                            subscription_price: null,
                            subscription_compare: null
                        };
                        
                        // Get subscription prices if available
                        if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
                            const allocation = variant.selling_plan_allocations[0];
                            variantData[variant.id].subscription_price = allocation.price;
                            variantData[variant.id].subscription_compare = allocation.compare_at_price || variant.price;
                        }
                    });
                    
                    console.log('AWTOMIC Aggressive Fix: Variant data captured', variantData);
                }
            } catch (e) {
                // Not JSON or not the right data
            }
        });
    }
    
    function setupObservers() {
        // Watch for AWTOMIC injecting price elements
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Check if AWTOMIC added price elements
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Element node
                            if (node.classList && (
                                node.classList.contains('bundleapp-compareAtPrice') ||
                                node.classList.contains('bundleapp-plan-selector-group-pricing') ||
                                node.dataset.test === 'bundlePriceOnSale'
                            )) {
                                console.log('AWTOMIC Aggressive Fix: AWTOMIC added price element, fixing...');
                                setTimeout(fixPrices, 100);
                            }
                        }
                    });
                }
                
                // Check for text changes in price elements
                if (mutation.type === 'characterData' || mutation.type === 'childList') {
                    const target = mutation.target;
                    if (target.nodeType === 3) { // Text node
                        const parent = target.parentElement;
                        if (parent && (
                            parent.classList.contains('product-price--original') ||
                            parent.classList.contains('bundleapp-compareAtPrice') ||
                            parent.classList.contains('bundleapp-plan-selector-group-pricing')
                        )) {
                            setTimeout(fixPrices, 100);
                        }
                    }
                }
            });
        });
        
        // Start observing the entire document
        observer.observe(document.body, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }
    
    function setupListeners() {
        // Listen for variant changes
        document.addEventListener('change', function(e) {
            const target = e.target;
            
            // Check if it's a variant selector
            if (target.name === 'id' || 
                target.classList.contains('product-variant-container') ||
                target.closest('.product-variant-container')) {
                
                console.log('AWTOMIC Aggressive Fix: Variant changed to', target.value);
                
                // Get the variant ID
                let variantId = target.value;
                if (!variantId) {
                    const form = target.closest('form');
                    const idInput = form ? form.querySelector('input[name="id"]') : null;
                    if (idInput) variantId = idInput.value;
                }
                
                if (variantId && variantData[variantId]) {
                    currentVariant = variantData[variantId];
                    console.log('AWTOMIC Aggressive Fix: Current variant data', currentVariant);
                    setTimeout(fixPrices, 200);
                }
            }
            
            // Check if it's a subscription selector
            if (target.name === 'bundleapp-plan-selector-group' ||
                target.classList.contains('bundleapp-plan-selector-select')) {
                console.log('AWTOMIC Aggressive Fix: Subscription changed');
                setTimeout(fixPrices, 200);
            }
        });
        
        // Also listen for clicks on radio buttons
        document.addEventListener('click', function(e) {
            if (e.target.type === 'radio' && 
                (e.target.name === 'bundleapp-plan-selector-group' || 
                 e.target.name === 'plan')) {
                console.log('AWTOMIC Aggressive Fix: Subscription clicked');
                setTimeout(fixPrices, 200);
            }
        });
    }
    
    function fixPrices() {
        console.log('AWTOMIC Aggressive Fix: Fixing prices...');
        
        // Get current variant ID from form
        const form = document.querySelector('form[action*="/cart/add"]');
        const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
        const variantId = variantIdInput ? variantIdInput.value : null;
        
        if (!variantId || !variantData[variantId]) {
            console.log('AWTOMIC Aggressive Fix: No variant data found for', variantId);
            return;
        }
        
        const variant = variantData[variantId];
        console.log('AWTOMIC Aggressive Fix: Using variant', variant);
        
        // Check if subscription is selected
        const subscriptionRadio = document.querySelector('input[name="bundleapp-plan-selector-group"]:checked');
        const isSubscription = subscriptionRadio && subscriptionRadio.value !== '';
        
        // Determine prices to show
        // When subscription is selected, compare price should be the one-time price
        let displayPrice, comparePrice;
        if (isSubscription && variant.subscription_price) {
            displayPrice = variant.subscription_price;
            comparePrice = variant.price; // Always show one-time price as compare when subscription selected
        } else {
            displayPrice = variant.price;
            comparePrice = variant.compare_at_price; // Only show compare if variant has one
        }
        
        console.log('AWTOMIC Aggressive Fix: Display price:', displayPrice, 'Compare price:', comparePrice);
        
        // Fix all price displays
        
        // 1. Fix subscription selector prices first (these need to be accurate)
        const oneTimePrice = document.querySelector('[data-one-time] .bundleapp-plan-selector-group-pricing');
        if (oneTimePrice) {
            oneTimePrice.textContent = formatMoney(variant.price);
        }
        
        const subscriptionPriceElement = document.querySelector('.bundleapp-plan-selector-group:not([data-one-time]) .bundleapp-plan-selector-group-pricing');
        if (subscriptionPriceElement && variant.subscription_price) {
            subscriptionPriceElement.textContent = formatMoney(variant.subscription_price);
        }
        
        // 2. Fix price containers (both compact and extended)
        const priceContainers = document.querySelectorAll('[data-js-product-price-extended], [data-js-product-price-compact]');
        priceContainers.forEach(container => {
            // Clear out any existing price structure
            const priceWrapper = container.querySelector('.product-price') || container;
            
            // Remove any existing AWTOMIC injected elements
            const awtomicElements = priceWrapper.querySelectorAll('.bundleapp-compareAtPrice');
            awtomicElements.forEach(el => el.remove());
            
            // Find or create main price element
            let mainPrice = priceWrapper.querySelector('.product-price--original, .price__current');
            if (!mainPrice) {
                mainPrice = document.createElement('span');
                mainPrice.className = 'product-price--original text-size--heading';
                priceWrapper.appendChild(mainPrice);
            }
            
            // Ensure main price has correct classes
            if (!mainPrice.classList.contains('text-size--heading')) {
                mainPrice.classList.add('text-size--heading');
            }
            
            mainPrice.textContent = formatMoney(displayPrice);
            mainPrice.style.display = 'inline';
            mainPrice.style.textDecoration = 'none';
            
            // Handle compare price
            let compareEl = priceWrapper.querySelector('.product-price--compare, del, s:not(.bundleapp-compareAtPrice)');
            
            if (comparePrice && comparePrice > displayPrice) {
                if (!compareEl) {
                    // Create compare element if it doesn't exist
                    compareEl = document.createElement('s');
                    compareEl.className = 'product-price--compare text-size--heading';
                    // Insert before main price
                    priceWrapper.insertBefore(compareEl, mainPrice);
                }
                
                compareEl.textContent = formatMoney(comparePrice);
                compareEl.style.display = 'inline';
                compareEl.style.textDecoration = 'line-through';
                compareEl.style.marginRight = '10px';
                
                // Also add the heading class if missing
                if (!compareEl.classList.contains('text-size--heading')) {
                    compareEl.classList.add('text-size--heading');
                }
            } else if (compareEl) {
                // Hide compare price if not needed
                compareEl.style.display = 'none';
            }
        });
        
        // 3. Fix any standalone price elements
        const standalonePrices = document.querySelectorAll('.product-price--original:not([data-js-product-price-extended] *, [data-js-product-price-compact] *), .price__current:not([data-js-product-price-extended] *, [data-js-product-price-compact] *)');
        standalonePrices.forEach(el => {
            el.textContent = formatMoney(displayPrice);
            el.style.display = 'inline';
            el.style.textDecoration = 'none';
            if (!el.classList.contains('text-size--heading')) {
                el.classList.add('text-size--heading');
            }
        });
        
        // 4. Fix any AWTOMIC bundleapp-compareAtPrice that might still exist
        const awtomicCompareElements = document.querySelectorAll('.bundleapp-compareAtPrice');
        awtomicCompareElements.forEach(el => {
            if (comparePrice && comparePrice > displayPrice) {
                el.textContent = formatMoney(comparePrice);
                el.style.textDecoration = 'line-through';
                el.style.display = 'inline';
                if (!el.classList.contains('text-size--heading')) {
                    el.classList.add('text-size--heading');
                }
            } else {
                el.remove(); // Remove it if not needed
            }
        });
        
        // 5. Ensure price structure is correct
        priceContainers.forEach(container => {
            const priceDiv = container.querySelector('.product-price');
            if (priceDiv) {
                // Ensure compare price comes before main price
                const compare = priceDiv.querySelector('.product-price--compare, s');
                const main = priceDiv.querySelector('.product-price--original');
                
                if (compare && main && compare.nextElementSibling !== main) {
                    priceDiv.insertBefore(compare, main);
                }
            }
        });
    }
    
    function formatMoney(cents) {
        const dollars = (cents / 100).toFixed(2);
        return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    
    // Run fix periodically to catch any AWTOMIC updates
    setInterval(function() {
        const needsFix = document.querySelector('.bundleapp-compareAtPrice[style*="display: inline"]');
        if (needsFix) {
            const text = needsFix.textContent;
            // Check if AWTOMIC is showing wrong price
            if (text && !text.includes(formatMoney(currentVariant ? currentVariant.price : 0))) {
                fixPrices();
            }
        }
    }, 1000);
    
    // Expose for debugging
    window.awtomicAggressiveFix = {
        fixPrices: fixPrices,
        variantData: variantData,
        currentVariant: () => currentVariant
    };
    
    console.log('AWTOMIC Aggressive Fix: Ready. Debug with window.awtomicAggressiveFix');
})();